<template>
  <v-card>
    <page>
      <v-card light rounded="lg" class="pa-10 text-center">
        {{ getText() }}
      </v-card>
    </page>
  </v-card>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page";

@Component({
  components: { Page }
})
class ProcessPayment extends Vue {
  getText() {
    return 'Платеж в обработке';
  }
}
export default ProcessPayment;
</script>

<style scoped>

</style>